import { FC } from "react";
import { withProcedureWraper } from "../../../..";
import { Icon } from "../../../../../../components";
import { useHistory } from "react-router-dom";
import { Routes } from "../../../../../../AppRoutes";
import {
  ExportProgress,
  ExportInformation,
  ExportHistory,
  ExportList,
} from "../../components";
import { CreateNotification } from "../../../../../../components/notifier";
import { SystemCode, requestStatus } from "../../../../../../constants";
import { useSelector } from "../../../../../../store/store";
import { Skeleton, Form, Modal, Input } from "antd";
import { PlanningDepartmentExportService } from "../../../../../../services/planning-department/export-warehouse";
import { useRouteMatch } from "react-router-dom";
import { getUCTDate } from "../../../../../../helper/dateTimeHelper";
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { getEnv } from "../../../../../../AppConfigs";
import { useEmployee, useSoftwares } from "../../../../../../hook";
import { StyledButton, StyledTitle } from "../../../../../../components/styled-antd";
import { isEnableEdit } from "../../../../human-organization/summary-employee-request/utils";
import { getApproverName } from "../../../../human-organization/summary-employee-request/utils/get-employee-detail";
import { sendEmail } from "../../../../human-organization/summary-employee-request/utils/send-mail";

export const exportWarehouseDetail: FC = withProcedureWraper(() => {
  const [form] = Form.useForm();

  const history = useHistory();
  const { id } = useRouteMatch().params as any;
  const [eRequests, setERequests] = useState<any[]>([]);
  const user = useSelector((state) => state.user);
  const currentUserName = user?.current?.username?.toString().toLowerCase();
  const mailtemplates = useSelector(
    (state: any) => state.systemMgmt.mailtemplates
  );
  const softwares = useSelector((state: any) => state.systemMgmt.softwares);
  const { getITLeadITHeadAssignee } = useSoftwares();

  const { data: employees } = useEmployee();

  const { data: detail, isLoading: isLoadingDetailRequest } = useQuery({
    queryKey: ["detail-request-export", id],
    queryFn: () => PlanningDepartmentExportService.getDetail(id),
    onSuccess: (data) => {
      setERequests(
        data?.fields?.eContent
          ? JSON.parse(data.fields.eContent).map((value: any) => {
              return {
                ...value,
                productName: value?.productName,
                Dram: value.Dram,
                requestedQuantity: value.requestedQuantity,
                approvedQuantity: value?.approvedQuantity,
                inventoryQuantity: value.inventoryQuantity,
                productLifetime: value?.productLifetime,
              };
            })
          : []
      );
    },
  });

  const approveRequest = async () => {
    try {
      if (getNextStep() === 1) {
        // const resp = await PlanningDepartmentExportService.updateRequest(id, {
        //   eApprovedStatus: requestStatus.approved,
        //   eApprovedDate: getUCTDate(),
        //   eRequestStatus: requestStatus.approved,
        //   eContent: JSON.stringify(eRequests),
        //   eApprovalComment: form.getFieldValue("comment") || "",
        // });

        sendEmail(
          detail,
          "EWRA",
          `${detail.fields.eApprovedByITLead}|${getApproverName(
            detail?.fields?.eApprovedByITLead,
            employees,
            softwares,
            getITLeadITHeadAssignee(SystemCode.EWR).eAssignee
          )}`,
          mailtemplates,
          "",
          siteUrl,
          form.getFieldValue("comment") || "",
          true
        );
      } else if (getNextStep() === 2) {
        for (const eRequest of eRequests) {
          if (!eRequest?.approvedQuantity) {
            CreateNotification({
              title: "Duyệt thất bại",
              body: `Vui lòng nhập số lượng xét duyệt`,
              icon: "/icons/error.png",
            });
            return;
          }
        }

        // const resp = await PlanningDepartmentExportService.updateRequest(id, {
        //   eApprovedByITLeadStatus: requestStatus.approved,
        //   eApprovedByITLeadDate: getUCTDate(),
        //   eRequestStatus: requestStatus.completed,
        //   eITLeadComment: form.getFieldValue("comment") || "",
        //   eContent: JSON.stringify(eRequests),
        // });

        sendEmail(
          detail,
          "EWRF",
          `${detail.createdBy.user.email}|${detail.createdBy.user.displayName}`,
          mailtemplates,
          "",
          siteUrl,
          form.getFieldValue("comment") || "",
          true
        );
      }

      CreateNotification({
        title: "Thành công",
        body: `Đồng ý thành công.`,
        icon: "/icons/success.png",
      });

      history.push(Routes.procedureExportWarehouse.path);
    } catch (error) {
      CreateNotification({
        title: "Thất bại",
        body: `Duyệt thất bại`,
        icon: "/icons/error.png",
      });

      history.push(Routes.procedureExportWarehouse.path);
    }
  };

  const isEnableAccept = () => {
    const nextStep = getNextStep();

    if (detail?.fields?.eRequestStatus === requestStatus.rejected) {
      return false;
    }

    if (
      detail?.fields?.eApprovedBy === currentUserName &&
      nextStep === 1 &&
      detail?.fields?.eApprovedStatus === requestStatus.submitted
    ) {
      return true;
    }
    if (
      detail?.fields?.pickedUser === currentUserName &&
      nextStep === 1 &&
      detail?.fields?.eApprovedStatus === requestStatus.submitted
    ) {
      return true;
    }

    if (
      detail?.fields?.eApprovedByITLead === currentUserName &&
      nextStep === 2 &&
      detail?.fields?.eApprovedByITLeadStatus === requestStatus.submitted
    ) {
      return true;
    }

    return false;
  };

  const isEnableRevoke = () => {
    const currentStep = getRevokeStep();

    if (currentStep === 1 && detail?.fields?.eApprovedBy === currentUserName) {
      return true;
    }

    return false;
  };

  const rejectRequest = async () => {
    try {
      if (getNextStep() === 1) {
        //call api
        await PlanningDepartmentExportService.updateRequest(id, {
          eApprovedStatus: "Rejected",
          eApprovedDate: getUCTDate(),
          eRequestStatus: "Rejected",
          eApprovalComment: form.getFieldValue("comment") || "",
        });
      } else if (getNextStep() === 2) {
        //call api
        await PlanningDepartmentExportService.updateRequest(id, {
          eApprovedByITLeadStatus: "Rejected",
          eApprovedByITLeadDate: getUCTDate(),
          eRequestStatus: "Rejected",
          eITLeadComment: form.getFieldValue("comment") || "",
        });
      }

      CreateNotification({
        title: "Thành công",
        body: `Từ chối thành công.`,
        icon: "/icons/success.png",
      });

      sendEmail(
        detail,
        "EWRR",
        `${detail.createdBy.user.email}|${detail.createdBy.user.displayName}`,
        mailtemplates,
        "",
        siteUrl,
        form.getFieldValue("comment") || "",
        true
      );

      history.push(Routes.procedureExportWarehouse.path);
    } catch (error) {
      CreateNotification({
        title: "Thất bại",
        body: `Từ chối thất bại`,
        icon: "/icons/error.png",
      });

      history.push(Routes.procedureExportWarehouse.path);
    }
  };

  const revokeApproval = async () => {
    const currentStep = getRevokeStep();
    try {
      if (currentStep === 1) {
        await PlanningDepartmentExportService.updateRequest(id, {
          eApprovedStatus: requestStatus.submitted,
          eRequestStatus: requestStatus.submitted,
        });
      }

      CreateNotification({
        title: "Thành công",
        body: `Thu hồi thành công.`,
        icon: "/icons/success.png",
      });

      history.push(Routes.procedureExportWarehouse.path);
    } catch (error) {
      CreateNotification({
        title: "Thất bại",
        body: `Thu hồi thất bại`,
        icon: "/icons/error.png",
      });

      history.push(Routes.procedureExportWarehouse.path);
    }
  };

  const getRevokeStep = () => {
    const nextStep = getNextStep();

    if (detail?.fields?.eRequestStatus === requestStatus.rejected) {
      return 0;
    }

    if (
      detail?.fields?.eApprovedBy === currentUserName &&
      nextStep === 2 &&
      detail?.fields?.eApprovedStatus === requestStatus.approved
    ) {
      return 1;
    }
    if (
      detail?.fields?.pickedUser === currentUserName &&
      nextStep === 2 &&
      detail?.fields?.eApprovedStatus === requestStatus.approved
    ) {
      return 1;
    }

    if (
      detail?.fields?.eApprovedByITLead === currentUserName &&
      nextStep === 3 &&
      detail?.fields?.eApprovedByITLeadStatus === requestStatus.approved
    ) {
      return 2;
    }

    return 0;
  };

  const getNextStep = () => {
    if (detail?.fields?.eRequestStatus === requestStatus.rejected) {
      return -1;
    }

    if (detail?.fields?.eApprovedStatus === requestStatus.submitted) {
      return 1;
    }

    if (detail?.fields?.eApprovedByITLeadStatus === requestStatus.submitted) {
      return 2;
    }
    return 3;
  };

  if (isLoadingDetailRequest) {
    return <Skeleton />;
  }

  const siteUrl = getEnv(
    "REACT_APP_APPROVER_EXPORT_WAREHOUSE_PLANNING_DEPARTMENT"
  );

  const showRejectConfirm = () => {
    Modal.confirm({
      title: <StyledTitle level={5}>Thông báo</StyledTitle>,
      content: (
        <>
          Bạn có chắc chắn muốn từ chối yêu cầu này ?
          <br />
          Vui lòng nhập lý do từ chối
          <br />
          <StyledTitle level={5}>
            Lý do <span className="text-danger ml-1">*</span>{" "}
          </StyledTitle>
          <Input
            onChange={(e: any) => {
              form.setFieldValue("comment", e.target.value);
            }}
          />
        </>
      ),
      okText: "Xác nhận",
      okType: "danger",
      okButtonProps: { type: "primary" },
      cancelText: "Huỷ",
      cancelButtonProps: {
        style: { backgroundColor: "orange", color: "white" },
      },

      onOk() {
        rejectRequest();
      },
      onCancel() {
        form.setFieldValue("comment", null);
      },
    });
  };

  return (
    <div className="ItCodeGrantedDetailPage pd15">
      <div className="PageHead">
        <div className="title">
          <div
            className="btnBack"
            onClick={() => history.push(Routes.procedureExportWarehouse.path)}
          >
            <Icon.ArrowLeft />
          </div>
          Xem Xét Yêu Cầu Duyệt
        </div>
      </div>

      <div className="row">
        <div className="col-lg-12 col-md-12">
          <ExportProgress />
          <ExportInformation />
          <ExportList
            eRequests={eRequests}
            setERequests={setERequests}
            hiddenEdit={
              !isEnableAccept() || getNextStep() === 1 || getNextStep() === 3
            }
          />
          <ExportHistory form={form} isEnableAccept={isEnableAccept()} />

          <div className="d-flex justify-content-center">
            {isEnableAccept() && (
              <StyledButton
                bgColor="green"
                className="mr-3"
                type="primary"
                onClick={approveRequest}
              >
                Đồng ý
              </StyledButton>
            )}

            {isEnableAccept() && (
              <StyledButton
                bgColor="grey"
                danger
                className="mr-3"
                onClick={showRejectConfirm}
              >
                Không đồng ý
              </StyledButton>
            )}

            {!isEnableAccept() && isEnableRevoke() && (
              <StyledButton
                bgColor="grey"
                type="primary"
                danger
                className="mr-3"
                onClick={revokeApproval}
              >
                Thu hồi
              </StyledButton>
            )}

            {isEnableEdit(getNextStep(), detail, currentUserName) && (
              <StyledButton
                bgColor="orange"
                onClick={() =>
                  history.push(
                    Routes.createExportWarehouse.path.replace(":id", id)
                  )
                }
              >
                Chỉnh sửa
              </StyledButton>
            )}
          </div>
        </div>
      </div>
    </div>
  );
});
